module.exports = __webpack_public_path__ + "static/media/undraw_welcome_3gvl.dfece2c1.svg";